import { HaNDetailsContext, useHaNRoom } from "@lib/logic";
import { useRequiredContext } from "@lib/utils";

import { PanelStack } from "../../shared/PanelStack/PanelStack";
import { RoomBookingPage } from "./RoomBookingPage";
import { RoomInfoPage } from "./RoomInfoPage";
import { RoomInviteesPage } from "./RoomInviteesPage";
import { RoomSensorInfoPage } from "./RoomSensorInfoPage";

export const RoomDetails = () => {
  const { selection } = useRequiredContext(HaNDetailsContext);

  if (selection.kind !== "room") return null;

  return <RoomDetailsContent roomId={selection.id} />;
};

const RoomDetailsContent = ({ roomId }: { roomId: string }) => {
  const { room, isLive } = useHaNRoom(roomId);

  if (!room) return null;

  return (
    <PanelStack initial="info">
      <PanelStack.Page pageId="info">
        <RoomInfoPage
          room={room}
          isLive={isLive}
        />
      </PanelStack.Page>

      <PanelStack.Page pageId="sensorInfo">
        <RoomSensorInfoPage />
      </PanelStack.Page>

      <PanelStack.Page pageId="booking">
        <RoomBookingPage room={room} />
      </PanelStack.Page>

      <PanelStack.Page pageId="invitees">
        <RoomInviteesPage room={room} />
      </PanelStack.Page>
    </PanelStack>
  );
};
